import { Helmet } from "react-helmet-async";
import { Zap, Target, Layers, Users, Sparkles, FileText } from "lucide-react";
import TierPageLayout from "@/components/pricing/TierPageLayout";

const AgencyTierPageContent = () => {
  return (
    <>
      <Helmet>
        <title>Agency Plan — $249/Month | Chat-native Google Ads for Freelancers | Upfixe</title>
        <meta name="description" content="Agency plan: 5 brands, unlimited campaigns, MCC support. $249/month — build a Google Ads campaign for any client in about 4 minutes." />
        <meta name="keywords" content="freelance PPC, agency tier, multi-brand Google Ads, MCC Google Ads, chat-native PPC" />
        <meta property="og:title" content="Agency Plan — $249/Month | Chat-native Google Ads for Freelancers | Upfixe" />
        <meta property="og:description" content="Agency plan: 5 brands, unlimited campaigns, MCC support. Build campaigns for any client in about 4 minutes." />
        <link rel="canonical" href="https://upfixe.com/plans/agency" />
      </Helmet>
      <TierPageLayout
      tierName="Agency"
      tagline="MOST POPULAR"
      headline="Build campaigns 10× faster across every client"
      subheadline="For freelancers and consultants managing 1–5 clients. Each brand gets its own value-prop doc and its own Google Ads sub-account binding."
      price={249}
      priceNote="Billed monthly · 7-day free trial · or $2,490/yr"
      bestFor="Freelancers & small consultancies"
      audienceDescription="At 5 brands, that's $50/brand/month. Charge your client $200 for ongoing PPC management and pocket the margin."
      features={[
        {
          icon: <Layers className="h-5 w-5" />,
          title: "5 brands, isolated value-prop docs",
          description: "Each client gets their own brief, their own positioning, their own ad copy logic. No bleed between accounts."
        },
        {
          icon: <Users className="h-5 w-5" />,
          title: "MCC + sub-account support",
          description: "Bind each brand to its own Google Ads sub-account under your manager (MCC). Switch clients in chat."
        },
        {
          icon: <Zap className="h-5 w-5" />,
          title: "Unlimited campaigns per brand",
          description: "Search campaigns, multiple ad groups, A/B copy variants. Whatever each client needs."
        },
        {
          icon: <Target className="h-5 w-5" />,
          title: "Multi-brand reporting",
          description: "Roll up performance across all your clients or drill into one. Date-ranged, lifetime, by-brand."
        },
        {
          icon: <Sparkles className="h-5 w-5" />,
          title: "Negative-keyword strategy per brand",
          description: "Off-vertical, informational, competitor, brand-research exclusions — tailored to each client's positioning."
        },
        {
          icon: <FileText className="h-5 w-5" />,
          title: "Client-ready exports",
          description: "Pull a clean performance summary you can drop into a client update or invoice email."
        }
      ]}
      limits={[
        "5 brands",
        "Unlimited campaigns per brand",
        "Unlimited reports",
        "MCC + sub-account support",
        "Per-brand value-prop docs",
        "All Solo features"
      ]}
      useCases={[
        {
          title: "Freelance PPC consultants",
          description: "Manage a small roster of clients without drowning in dashboards. Charge agency rates with solo overhead."
        },
        {
          title: "Marketing freelancers expanding into PPC",
          description: "Your existing clients want paid acquisition. You don't want to learn the Google Ads UI from scratch."
        },
        {
          title: "Two-person marketing studios",
          description: "Punch above your weight on a small client roster. Pitch deliverables your competitors can't match on speed."
        },
        {
          title: "Founders running 2–5 brands",
          description: "Portfolio operator with multiple businesses. Manage them all from one Upfixe seat."
        }
      ]}
      ctaText="Start 7-day free trial"
    />
    </>
  );
};

export default AgencyTierPageContent;
